import {useEffect} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import productService from '../../../services/product/productService';
import yapConnectionService from '../../../services/yap/yapConnectionService';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../../state/selectors/consumer';
import {
    selectIsScpCheckInProgress,
    selectIsSkipRegistration,
    selectIsStartAutoSync,
} from '../../../state/selectors/global';
import {selectIsDeviceReady, selectIsFirmwareInProgress} from '../../../state/selectors/iotDevice';
import {
    makeSelectIsYapActivationInProgress,
    makeSelectIsYapDeviceInfoReceived,
    makeSelectIsYapFirmwareInProgress,
    makeSelectIsYapUpdateSettingsInProgress,
} from '../../../state/selectors/yapEncrypted';

const mapStateToProps = createStructuredSelector({
    iotProduct: makeSelectIotDeviceMergedWithConsumerProduct(),
    isDeviceReady: selectIsDeviceReady,
    isYapDeviceInfoReceived: makeSelectIsYapDeviceInfoReceived(),
    isStartAutoSync: selectIsStartAutoSync,
    isScpCheckInProgress: selectIsScpCheckInProgress,
    isFirmwareInProgress: selectIsFirmwareInProgress,
    isYapActivationInProgress: makeSelectIsYapActivationInProgress(),
    isYapUpdateSettingsInProgress: makeSelectIsYapUpdateSettingsInProgress(),
    isYapFirmwareInProgress: makeSelectIsYapFirmwareInProgress(),
    isSkipRegistration: selectIsSkipRegistration,
});

const DeviceConnectionChecker = ({
    iotProduct,
    isDeviceReady,
    isYapDeviceInfoReceived,
    isStartAutoSync,
    isScpCheckInProgress,
    isFirmwareInProgress,
    isYapActivationInProgress,
    isYapUpdateSettingsInProgress,
    isYapFirmwareInProgress,
    isSkipRegistration,
}) => {
    const {device} = iotProduct || {};
    const {status: deviceStatus, deviceSerialNumber} = device || {};
    const isCurrentDeviceRegistered = productService.getIsRegistered(deviceStatus);
    const isRegAllowsStart = isCurrentDeviceRegistered || isSkipRegistration;
    const isStartSync =
        deviceSerialNumber &&
        isRegAllowsStart &&
        isDeviceReady &&
        !isYapDeviceInfoReceived &&
        isStartAutoSync &&
        !isScpCheckInProgress &&
        !isFirmwareInProgress &&
        !isYapActivationInProgress &&
        !isYapUpdateSettingsInProgress &&
        !isYapFirmwareInProgress;

    useEffect(() => {
        if (isStartSync) {
            yapConnectionService.initSynchronizeFlow();
        }
    }, [isStartSync]);

    return null;
};

export default connect(mapStateToProps)(DeviceConnectionChecker);
